module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('z-basePage', {
    attrs: {
      "title": _vm.title,
      "pop": true
    }
  }, [_c('z-backForm', {
    attrs: {
      "name": 'back-currency',
      "align": true
    },
    on: {
      "save": _vm.saveSet,
      "cancel": _vm.backset
    }
  }, [_c('div', {
    staticClass: "back-item"
  }, [_c('div', {
    staticClass: "back-title"
  }, [_vm._v("快币名称")]), _vm._v(" "), _c('div', {
    staticClass: "back-wrap text"
  }, [(_vm.type == 20) ? _c('div', [_vm._v(_vm._s(_vm.sub.name))]) : _c('el-input', {
    directives: [{
      name: "arg",
      rawName: "v-arg",
      value: ([0, 5]),
      expression: "[0,5]"
    }, {
      name: "tar",
      rawName: "v-tar",
      value: (_vm.sub.name),
      expression: "sub.name"
    }],
    staticClass: "top-choose",
    attrs: {
      "rule": "limit",
      "placeholder": "请输入快币名称"
    },
    model: {
      value: (_vm.sub.name),
      callback: function($$v) {
        _vm.$set(_vm.sub, "name", $$v)
      },
      expression: "sub.name"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "back-item area"
  }, [_c('div', {
    staticClass: "back-title"
  }, [_vm._v("快币描述")]), _vm._v(" "), _c('div', {
    staticClass: "back-wrap"
  }, [_c('textarea', {
    directives: [{
      name: "arg",
      rawName: "v-arg",
      value: ('快币描述'),
      expression: "'快币描述'"
    }, {
      name: "tar",
      rawName: "v-tar",
      value: (_vm.sub.describe),
      expression: "sub.describe"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.sub.describe),
      expression: "sub.describe"
    }],
    attrs: {
      "rule": "reason describe_limit",
      "placeholder": "请输入快币描述"
    },
    domProps: {
      "value": (_vm.sub.describe)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sub, "describe", $event.target.value)
      }
    }
  })])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-4c18b5fe!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/backEndStage/setting/page-currencyAdd.vue
// module id = 741
// module chunks = 1